module.exports = __webpack_public_path__ + "fonts/6b9f2ce10c32771b94d8dd5bfed3e60b.svg";